// frontend/src/themes/palettes/cafe.js
import { sharedComponents } from "./shared";
export default {
  muiMode: "light",
  scrollbarColor: "#C4A484",
  palette: {
    primary:    { main: "#6D4C41" },
    secondary:  { main: "#A1887F" },
    background: { default: "#F7F1E8", paper: "#FFFDF9" },
    text:       { primary: "#3E2C24", secondary: "#6E5A4E" },
    divider:    "#E6D9C8",
    action:     { hover: "rgba(109,76,65,0.05)", selected: "rgba(109,76,65,0.09)" },
  },
  components: {
    ...sharedComponents,
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 6, backgroundColor: "#FFFDF9" },
        notchedOutline: { borderColor: "#CDB89F" },
      },
    },
  },
  custom: {
    chat: {
      sentBg: "#EFE3D3", receivedBg: "#FFFDF9",
      quotedSentBg: "#E4D3BC", quotedReceivedBg: "#F3EBDE", accent: "#6D4C41", contactAccent: "#A1887F",
    },
    chartPalette: ["#6D4C41", "#A1887F", "#D7A86E", "#8D6E63", "#C49A6C", "#795548"],
    login: { bg: "#F7F1E8" },
  },
};
